// dev
  // export default {
  //   domain: 'localhost',
  //   basePath: '/',
  //   apiUrl: '//declick-serveur.localhost/api/',
  //   clientUrl: '//declick-client.localhost/',
  //   cmsUrl: '//v2.declick.net/cms/',
  //   forumUrl: '//test.declick.net/forum',
  //   wikiUrl: '//create.declick.net/wiki/',
  //   googleId: false,
  //   default_circuits_images: '//www.declick.net/images/default-level.png'
  // }
  //v2.declick.net/client/index.html#editor=true&token=wDVsz2aox5uH2Z30hBI0InjUfiZPQZAa&id=6960&wiki=false
  //declick-client.localhost/index.html#editor=true&token=HjRCj3pg1W7Z2yBIhrMZdE8sbCvSfqw3&id=6955&wiki=false
// prod
export default {
  domain:"declick.net",
  basePath:"/",
  apiUrl:"//declick.net/server/api/",
  clientUrl:"//declick.net/client/",
  cmsUrl:"//declick.net/cms/",
  forumUrl:"//create.declick.net/forum",
  wikiUrl:"//create.declick.net/wiki/",
  googleId:"UA-9457907-8",
  default_circuits_images:"//declick.net/images/default-level.png"
}
// v2.delick.net
// export default { 
//   domain:"v2.declick.net",
//   basePath:"/",
//   apiUrl:"//v2.declick.net/server/public/api/",
//   clientUrl:"//v2.declick.net/client/",
//   cmsUrl:"//v2.declick.net/cms/",
//   forumUrl:"//test.declick.net/forum",
//   wikiUrl:"//create.declick.net/wiki/",
//   googleId:!1,
//   default_circuits_images:"//www.declick.net/images/default-level.png"
// }


// WEBPACK FOOTER //
// ./src/assets/config/declick.js